var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "AnalysisQuestions" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "CardTypeId",
                        error: _vm.$v.form.CardTypeId
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.CardTypeId,
                          url:
                            "VisionNextFieldAnalysis/api/AnalysisQuestions/GetQuestionCardType"
                        },
                        on: {
                          input: function($event) {
                            _vm.selectedSearchType("CardTypeId", $event)
                            _vm.form.AnswerTypeId = null
                            _vm.AnswerType = null
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "AnswerTypeId",
                        error: _vm.$v.form.AnswerTypeId
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          source: _vm.answers,
                          label: "Description1",
                          disabled: !_vm.form.CardTypeId
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType(
                              "AnswerTypeId",
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.AnswerType,
                          callback: function($$v) {
                            _vm.AnswerType = $$v
                          },
                          expression: "AnswerType"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _vm.form.AnswerTypeId === 1 || _vm.form.AnswerTypeId === 5
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t(
                          "insert.AnalysisQuestions.QuestionOptions"
                        )
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.customerQuestionChoiceItems },
                        model: {
                          value: _vm.form.QuestionChoices,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "QuestionChoices", $$v)
                          },
                          expression: "form.QuestionChoices"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e8ecddb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e8ecddb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AnalysisQuestions/insert.vue
// module id = null
// module chunks = 